module.exports = __webpack_public_path__ + "static/img/medal2.eeb3b81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/4/medal2.png
// module id = TXCh
// module chunks = 1